import { useAuth } from '../auth/AuthContext.jsx'

export default function Login() {
  const { login } = useAuth()

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bg-base px-4">
      {/* Card */}
      <div
        className="w-full max-w-sm rounded-2xl border border-white/8 p-8 flex flex-col items-center gap-6"
        style={{
          background: 'linear-gradient(160deg, rgba(10,16,40,0.98) 0%, rgba(6,10,28,0.98) 100%)',
          boxShadow: '0 32px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(0,212,255,0.05)',
        }}
      >
        {/* Logo / brand */}
        <div className="flex flex-col items-center gap-2 text-center">
          <div className="w-12 h-12 rounded-2xl bg-cyan-500/15 border border-cyan-500/30 flex items-center justify-center mb-1">
            <svg viewBox="0 0 24 24" className="w-6 h-6 text-cyan-400 fill-current">
              <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
            </svg>
          </div>
          <div>
            <h1 className="text-lg font-black text-white tracking-tight">AEO × CereBI</h1>
            <p className="text-xs text-slate-500 mt-0.5">Supply Chain Analytics</p>
          </div>
        </div>

        <div className="w-full h-px bg-white/5" />

        <div className="text-center">
          <p className="text-sm text-slate-300 font-medium">Sign in to continue</p>
          <p className="text-xs text-slate-500 mt-1">Access is restricted to authorized accounts.</p>
        </div>

        <button
          onClick={login}
          className="w-[280px] py-2.5 rounded-lg bg-cyan-500 hover:bg-cyan-400 text-slate-950 text-sm font-semibold transition-colors"
        >
          Sign in
        </button>
      </div>

      <p className="mt-6 text-xs text-slate-600">
        Contact your administrator to request access.
      </p>
    </div>
  )
}
